import * as e from "react";
const h = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SZ_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SZ_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 5h-1v14h34V5H0z",
      fill: "#C51918",
      stroke: "#FFD018",
      strokeWidth: 2
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.149 9.33c-.12 0-.217-.272-.217-.606 0-.335.097-.606.217-.606h17.41c.12 0 .218.271.218.606 0 .334-.097.606-.217.606H7.149z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.096 8.601l1.01-1.29 1.79 1.29-1.79 1.324-1.01-1.324z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.149 13.33c-.12 0-.217-.271-.217-.606 0-.335.097-.606.217-.606h17.41c.12 0 .218.271.218.606 0 .335-.097.606-.217.606H7.149z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.096 12.601l1.01-1.29 1.79 1.29-1.79 1.324-1.01-1.324z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.346 15.82c-.16 0-.291-.307-.291-.687 0-.38.13-.688.29-.688H27.69c.16 0 .291.308.291.688 0 .38-.13.688-.29.688H4.345z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.816 12.052s2.842-5.98 6.906-5.98 7 5.98 7 5.98-3.586 5.902-6.953 5.902c-3.366 0-6.953-5.902-6.953-5.902z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SZ_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 8,
      y: 6,
      width: 15,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.816 12.052s2.842-5.98 6.906-5.98 7 5.98 7 5.98-3.586 5.902-6.953 5.902c-3.366 0-6.953-5.902-6.953-5.902z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SZ_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.923 5.68s-.927 1.126-.618 2.2c.31 1.074 1.03.96 1.03 1.906s-.333 1.91 0 1.91c.332 0 .447.653.143 1.095-.304.443-.573.457-.555 1.177.018.72 1.592 1.427.83 1.427-.763 0-1.768.74-1.448.74.32 0 1.993.576 1.993 1.333v1.363H8.57V5.68h7.353z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.817 9.923h-.434v1.77h.434v-1.77zm1.282 0h-.435v1.77h.435v-1.77zm-1.075 0h.434v1.77h-.434v-1.77zm1.715 0h-.434v1.77h.434v-1.77zm.206 0h.435v1.77h-.435v-1.77zm1.075 0h-.434v1.77h.434v-1.77zm-3.637 2.538h.434v1.77h-.434v-1.77zm1.716 0h-.435v1.77h.434v-1.77zm-1.076 0h.435v1.77h-.435v-1.77zm1.716 0h-.434v1.77h.434v-1.77zm.206 0h.435v1.77h-.435v-1.77zm1.075 0h-.434v1.77h.434v-1.77z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.977 9.923h-.434v1.77h.434v-1.77zm1.282 0h-.435v1.77h.435v-1.77zm-1.075 0h.434v1.77h-.434v-1.77zm1.715 0h-.434v1.77h.434v-1.77zm.206 0h.435v1.77h-.434v-1.77zm1.075 0h-.434v1.77h.434v-1.77zm-3.637 2.538h.434v1.77h-.434v-1.77zm1.716 0h-.435v1.77h.435v-1.77zm-1.075 0h.434v1.77h-.434v-1.77zm1.715 0h-.434v1.77h.434v-1.77zm.206 0h.435v1.77h-.434v-1.77zm1.075 0h-.434v1.77h.434v-1.77z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M13.23 7.071c-.608.189-.886 1.785-.819 2.17.069.386.275-.048.275-.048s.421.915.464 1.161c.044.247.265-.372.265-.372s.73.503.83 1.064c.099.56.247-.641.247-.641l.166-.03-.105-.593.315.27-.097-.553s.238.311.177-.03l-.093-.533-.083-.468.313-.055s-1.246-1.53-1.855-1.342z",
      fill: "#3D58DB"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.088 13.695c-.632.08-1.184 1.603-1.184 1.995 0 .391.279 0 .279 0s.256.974.256 1.224.326-.32.326-.32.631.622.631 1.191c0 .57.355-.588.355-.588h.168v-.603l.264.32v-.56s.18.347.18 0v-1.016h.317s-.96-1.723-1.592-1.643zM5.592 13.464c.632.08 1.183 1.604 1.183 1.995 0 .392-.278 0-.278 0s-.256.975-.256 1.225c0 .25-.326-.32-.326-.32s-.632.621-.632 1.19c0 .57-.355-.588-.355-.588H4.76v-.603l-.264.32v-.56s-.18.347-.18 0V15.108H4s.961-1.724 1.593-1.644z",
      fill: "#3D58DB"
    }
  ))
), v = h;
export {
  v as default
};
